import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from '@angular/router';
import { combineLatest, forkJoin, Observable, zip } from 'rxjs';
import { MessagesService } from 'app/layout/common/messages/messages.service';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { QuickChatService } from 'app/layout/common/quick-chat/quick-chat.service';
import { ShortcutsService } from 'app/layout/common/shortcuts/shortcuts.service';
import { UserService } from 'app/core/user/user.service';
import { AuthService } from 'app/core/auth/auth.service';
import { FeesService } from './core/fees/fees.service';
import { BasketService } from './layout/common/basket/basket.service';

@Injectable({
    providedIn: 'root',
})
export class InitialDataResolver implements Resolve<any> {
    /**
     * Constructor
     */
    constructor(
        // private _messagesService: MessagesService,
        private _navigationService: NavigationService,
        private _notificationsService: NotificationsService,
        // private _quickChatService: QuickChatService,
        // private _shortcutsService: ShortcutsService,
        private _userService: UserService,
        private _feesService: FeesService // private _filterService: FilterService
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {
        // if (
        //     this._authService.accessToken &&
        //     AuthUtils.isTokenExpired(this._authService.accessToken)
        // ) {
        //     return forkJoin([
        //         this._authService.callRefreshToken(
        //             this._authService.accessToken
        //         ),
        //     ]);
        // }

        // this._filterService.initFilters();

        // Fork join multiple API endpoint calls to wait all of them to finish
        return forkJoin([
            this._navigationService.get(),
            // this._messagesService.getAll(),
            this._notificationsService.getAll(),
            // this._quickChatService.getChats(),
            // this._shortcutsService.getAll(),
            this._userService.get(),
            this._feesService.get(),
        ]);
    }
}

@Injectable({
    providedIn: 'root',
})
export class BasketDataResolver implements Resolve<any> {
    /**
     * Constructor
     */
    constructor(private _basketService: BasketService) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(): Observable<any> {
        return forkJoin([
            this._basketService.getAll(),
            this._basketService.getSessionBasket(),
        ]);
    }
}
